module.exports = __webpack_public_path__ + "img/title-text.f7ae55ea.png";